export const PRESENTATIONAL = Symbol('__presentational__');
export const COMPONENT_ID = Symbol('__componentId__');
export const CONNECTED = Symbol('__connected__');
export const PROPERTY_DEFS = Symbol('__propertyDefs__');
export const STATE = Symbol('__state__');
export const PROPS = Symbol('__props__');
export const ACTIONS = Symbol('__actions__');
export const ACTION_HANDLERS = Symbol('__actionHandlers__');
export const DISPATCH = Symbol('__dispatch__');
export const CONDITIONAL_DISPATCH = Symbol('__conditional_dispatch__');
export const ROOT_NODE = Symbol('__rootNode__');
export const VERSION = Symbol('__version__');
export const ATTACHED_ROOT_NODE = Symbol('__attached_root_node__');
export const UNHOIST = '__unHoist__';
export const DEFERRED = '__deferred__';
export const RENDER = Symbol('__render__');
export const LAST_HANDLE_STATE_CHANGE = Symbol('__last_handle_state_change__');
export const RENDER_SCHEDULED = Symbol('__render_scheduled__');
export const LAST_STATE_RENDERED = Symbol('__last_state_rendered__');
export const LAST_STATE_CHANGE = Symbol('__last_state_change__');
export const EVENT_HANDLERS = Symbol('__event_handlers__');
export const LIFE_CYCLE_COEFFECTS = Symbol('__life_cycle_coeffects__');
export const BOOTSTRAP_LIFECYCLE_RAN = Symbol('__bootstrap_lifecycle_ran__');
export const CONFIG = Symbol('__config__');
export const REMOVE_ACTION_HANDLERS = Symbol('__remove_action_handlers__');
export const RENDERED_ONCE = Symbol('__renders__');
export const TREE_RENDERED_ONCE = Symbol('__tree_renders__');
export const HELPERS_IMMEDIATE = Symbol('__helpers_immediate__');
export const HELPERS_DEFER = Symbol('__helpers_defer__');
export const HELPERS_SCHEDULED = Symbol('__helpers_scheduled__');
export const RETARGETED_ACTION_TYPES = Symbol('__retargeted_action_types__');
export const TARGETED_ACTION_TYPES = Symbol('__targeted_action_types__');
export const STYLE_PROXY = Symbol('__style_proxy__');
export const GET_RESOLVED_PROPERTY = Symbol('__get_resolved_property__');
export const HOIST_CHANGED = Symbol('__hoist_changed__');
export const HOIST_PARENT_CHANGED = Symbol('__hoist_parent_changed__');
export const SET_PROPERTY = Symbol('__set_property__');
export const HOIST_COMPOSED_PATH = Symbol('__hoist_composed_path__');
export const BOOTSTRAPPED_HANDLED = Symbol('__bootstrapped_handled__');
export const CONNECTED_HANDLED = Symbol('__connected_handled__');
export const PREVIOUS_RENDER_STATE = Symbol('__previous_render_state__');
export const PREVIOUS_RENDER_PROPERTIES = Symbol('__previous_render_properties__');
export const PREVIOUS_TREE_RENDER_STATE = Symbol('__previous_tree_render_state__');
export const PREVIOUS_TREE_RENDER_PROPERTIES = Symbol('__previous_tree_render_properties__');
export const CHILDREN_TO_BE_RENDERED = Symbol('__children_to_be_rendered__');
export const CHECK_IF_TREE_RENDERED = Symbol('__check_if_tree_rendered__');
export const CHILD_IS_RENDERING = Symbol('__child_is_rendering__');
export const CHILD_HAS_RENDERED = Symbol('__child_has_rendered__');
export const NOTIFY_PARENT_THAT_CHILD_IS_RENDERING = Symbol(
	'__notify_parent_that_child_is_rendering__'
);
export const NOTIFY_PARENT_THAT_CHILD_TREE_HAS_RENDERED = Symbol(
	'__notify_parent_that_child_tree_has_rendered__'
);
export const NEEDS_TO_KNOW_ABOUT_TREE_RENDERS = Symbol('__needs_to_know_about_tree_renders__');
export const ANCESTOR_ROOT_NODE = Symbol('__ancestor_root_node__');
export const ANCESTOR_PATH = Symbol('__ancestor_path__');
export const UPDATE_AFFECTED_COMPONENTS = Symbol('__update_affected_components__');
export const RUNTIME_ACTION_HANDLERS = Symbol('__runtime_action_handlers__');
export const USING_INTERSECTION_OBSERVER = Symbol('__using_intersection_observer__');
export const INTERSECTED = Symbol('__intersected__');
export const INTERSECTION_TRIGGERED = Symbol('__intersection_triggered__');
export const REMOVE_INTERSECTED_STYLES = Symbol('__remove_intersected_styles__');
export const DETACHED_SHADOW_ROOT_CHILDREN_FRAGMENT = Symbol(
	'__detached_shadow_root_children_fragment__'
);
export const DETACHED_COMPONENT_PROPERTY_MAP = Symbol('__detached_component_property_map__');
export const LOW_PRIORITY_PENDING = Symbol('__low_priority_pending__');
export const INTERACTIVE_TIMESTAMP = Symbol('__interactive_timestamp__');
export const CONNECTED_TIMESTAMP = Symbol('__connected_timestamp__');
export const CHILDREN_TO_BE_INTERACTIVE = Symbol('__children_to_be_interactive__');
export const SELECTABLE_PROPERTIES = Symbol('__SELECTABLE_PROPERTIES__');
export const PROPERTIES_WITH_SELECTOR = Symbol('__properties_with_selector__');
export const PROPERTIES_WITH_NESTED_SELECTOR = Symbol('__properties_with_nested_selector__');
export const TREE_RENDERED_ONCE_TIMESTAMP = Symbol('__tree_rendered_once_timestamp__');
export const RENDERED_ONCE_TIMESTAMP = Symbol('__rendered_once_timestamp__');
export const CONNECTED_DEFERRED_TIMESTAMP = Symbol('__connected_deferred_timestamp__');
export const CONTEXT = Symbol('__context__');
export const CONTEXT_VIEW_KEY = Symbol('__context_view_key__');
export const CONTEXT_RESOLVED_VALUE = Symbol('__context_resolved_value__');
export const REMOVE_UPDATE_CUSTOM_ELEMENT_OBSERVER = Symbol(
	'__remove_update_custom_element_observer__'
);
export const PREVIOUS_INTERACTION_ID = Symbol('__previous_interaction_id__');
export const PREVIOUS_TRACE_ID = Symbol('__previous_trace_id__');

export const HAS_NOW_RESOLVED_PROPS = Symbol('__has_now_resolved_props__');

export {
	VARIABLES,
	INTERNAL_HOST_DISPATCH,
	EXISTING_SHADOW_ROOT_ON_CREATE
} from '@servicenow/ui-internal';
